<template>
  <div style="margin-right: 30px">
    <v-btn large>{{ label }}</v-btn>
  </div>
</template>

<script>
export default {
  name: 'SaveButton',
  props: {
    label: {
      default: 'Save'
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "src/assets/css/variables.scss";
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background-color: $submit-color;
    color: white;
    display:block;
    border-radius: 20px;
    width: $width-button;
    border: 1px solid $submit-color;
    margin: $margin-button;
    height: $height-button;
  }
</style>
